import React, { useState, useRef, useLayoutEffect } from 'react';
import { Tooltip } from 'antd';

interface EllipsisTooltipProps {
  text: any;
  style?: React.CSSProperties;
}

export const EllipsisTooltip: React.FC<EllipsisTooltipProps> = ({ text, style }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  const checkTruncation = () => {
    const el = textRef.current;
    if (el) {
      // scrollWidth > clientWidth + 1 accounts for subpixel browser rendering
      setIsTruncated(el.scrollWidth > el.clientWidth + 1);
    }
  };

  useLayoutEffect(() => {
    checkTruncation();
  }, [text]);

  if (text === null || text === undefined || text === '') return null;
  const str = String(text);

  return (
    <Tooltip
      title={isTruncated ? str : ''}
      placement="topLeft"
      overlayStyle={{ maxWidth: 450, wordBreak: 'break-word' }}
    >
      <span
        ref={textRef}
        onMouseEnter={checkTruncation}
        style={{
          display: 'inline-block',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          verticalAlign: 'middle',
          cursor: isTruncated ? 'pointer' : 'inherit',
          ...style,
        }}
      >
        {str}
      </span>
    </Tooltip>
  );
};
